import { lazy } from 'react'
import type { RouteObject } from 'react-router'
const PageAcces = lazy(() => import('./PageAcces').then((m) => ({ default: m.PageAcces })))
export const routesAcces: RouteObject[] = [{ index: true, element: <PageAcces /> }]
